module.exports = __webpack_public_path__ + "media/images/emoticons/fish-69f371a00684a33499d13dec888f2743.gif";